// eslint-disable-next-line import/prefer-default-export
export const defaultTypes = {
  code: '',
  country: '',
  eu: false,
  vatName: '',
  phoneCode: '',
  vatPercent: 0,
};
